import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Inject, NgModule, Output } from '@angular/core';
import { FooterLogosModule } from '@commons/footer/footer-logos/footer-logos.component';
import { BreakpointsService } from '@core/services/breakpoints/breakpoints.service';
import { EmployerRoutingEnum } from '@features/employer/employer-routing.enum';
import { FeaturesRoutingEnum } from '@features/features-routing.enum';
import { MENU, NavItem } from '@models/menu/menu';
import { MenuTrackEventsEnum } from '@models/menu/navigation-tracker-actions.enum';
import { SharedModule } from '@shared/shared.module';
import { trackEventWithAtInternet } from '@wizbii/tracking';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  @Output() contactUs = new EventEmitter<void>();

  isCollapsed = {
    about: true,
    plan: true,
    links: true,
  };

  get isMobile$(): Observable<boolean> {
    return this.breakpointsService.isMobile$;
  }

  MENU = MENU;
  MenuTrackEventsEnum = MenuTrackEventsEnum;
  FeaturesRoutingEnum = FeaturesRoutingEnum;
  EmployerRoutingEnum = EmployerRoutingEnum;
  trackEvent = trackEventWithAtInternet;

  constructor(
    @Inject(DOCUMENT) private readonly document: any,
    private readonly breakpointsService: BreakpointsService
  ) {}

  openCookiesModal(): void {
    this.document.dispatchEvent(new CustomEvent<void>('WizbiiGdpr.toggleDialogVisibility'));
  }

  trackByMenuItem(_: number, navItem: NavItem): string {
    return navItem.label;
  }
}

@NgModule({
  imports: [SharedModule, FooterLogosModule],
  declarations: [FooterComponent],
  exports: [FooterComponent],
})
export class FooterModule {}
